import { I18nLanguageCode } from '@gruposaltaedu/liv-i18n/locale';

export function isBrazilExclusiveFeatureVisible(
  language: I18nLanguageCode
): boolean {
  return language === 'pt-BR';
}
